// import React, { useRef, useState } from "react";
// import emailjs from "@emailjs/browser";
// import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { Tooltip } from "./Tooltip";

const Contact = () => {
  // const form = useRef();
  // const [sendingMail, setSendingMail] = useState(false);

  // const sendEmail = (e) => {
  //   e.preventDefault();
  //   setSendingMail(true);
  //   emailjs
  //     .sendForm(
  //       "service_i8Fk3ms",
  //       "template_siFcin9",
  //       form.current,
  //       "c9HsFgGF0tFWyVnAL"
  //     )
  //     .then(
  //       (result) => {
  //         document.getElementById("contact-form").reset();
  //         toast.success("Message sent successfully!", {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //         console.log(result.text);
  //         setSendingMail(false);
  //       },
  //       (error) => {
  //         toast.error("Something went wrong!", {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //         console.log(error.text);
  //         setSendingMail(false);
  //       }
  //     );
  // };

  return (
    <section id="contact" className="section bg-light">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8 wow fadeInUp">
            <h2 className="text-10 fw-600 mb-4">Let's talk about Everything!</h2>
            <p className="text-5 mb-5">
              I enjoy discussing new ideas and challenges that involve technology, cloud, containers, Kubernetes, DevOps, and anything else.
            </p>
            <h3 className="text-5 fw-600 mb-2">Email</h3>
            <p className="text-6 mb-5">
              <a className="link-light" href="mailto:kasun.dsilva@gmail.com">
                kasun.dsilva@gmail.com
              </a>
            </p>
            <ul className="social-icons social-icons-lg justify-content-center mt-5">
              <li className="social-icons-facebook">
                <Tooltip text="LinkedIn" placement="top">
                  <a
                    href="https://www.linkedin.com/in/kasundsilva/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin" />
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-github">
                <Tooltip text="Github" placement="top">
                  <a
                    href="https://github.com/kasundsilva"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-github" />
                  </a>
                </Tooltip>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
